import { makeStyles } from '@material-ui/core/styles';

const defaultWidth = 675;
const previewWidth = 800;

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiDialog-paper': {
            width: (props) => (props.showPreview ? previewWidth + theme.spacing(6) : defaultWidth),
            maxWidth: (props) => (props.showPreview ? previewWidth + theme.spacing(6) : defaultWidth),
        },

        '& .MuiFormControl-root': {
            marginRight: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },

        '& .MuiFormLabel-root': {
            whiteSpace: 'nowrap',
        },
    },
    closeButton: {
        float: 'right',
        marginTop: theme.spacing(-1),
        marginRight: theme.spacing(-1),
    },
    leftActions: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.justifyItemsStart,
        ...theme.mixins.flex.grow(1),
    },
    reportPreview: {
        width: previewWidth,
        height: 500,
        backgroundColor: theme.palette.background.default,
    },
    reportPreviewImage: {
        width: '100%',
    },
    reportPreviewImageContainer: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        ...theme.mixins.flex.grow(1),
    },
    reportPreviewError: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.justifyItemsCenter,
        ...theme.mixins.flex.alignItemsCenter,

        '& svg': {
            marginRight: theme.spacing(1),
            color: theme.palette.alert.error,
        },
    },
    reportPreviewBackdrop: {
        position: 'relative',
        zIndex: 'inherit',
        width: '100%',
        ...theme.mixins.flex.grow(1),
    },
    timeZone: {
        width: 300,
        display: 'inline-block',
    },
    dayOfMonth: {
        width: 100,
        display: 'inline-block',
    },
    filterContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
    },
    filterLabel: {
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    filterValue: {
        fontSize: 16,
        padding: '2px 0 3px 0',
        borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
        marginBottom: 1,

        '&:hover': {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
            marginBottom: 0,
        },
    },
}));

export default useStyles;
